import { render } from "./RectanglesConfig.vue?vue&type=template&id=0642caff&scoped=true"
import script from "./RectanglesConfig.vue?vue&type=script&lang=js"
export * from "./RectanglesConfig.vue?vue&type=script&lang=js"

import "./RectanglesConfig.vue?vue&type=style&index=0&id=0642caff&scoped=true&lang=css"

import exportComponent from "/dev/shm/repo/airmap-2s5z7ythbr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0642caff"]])

export default __exports__